export default __webpack_public_path__ + "static/media/welcome-purple.6df72b90.svg";